/**
 * 스카이차 안전실천 서약서 (/m/sign/safety — 내부, /m/sign/safety/{mb_no}/{pass} — 외부 링크)
 * [서명하기] → 서명 BS($j.F.Member.ModalSafetySign) → 저장. 로그인 회원이면 내부 저장, 아니면 외부(remote) 저장.
 * 값은 blade #page-data (mbNo·pass 는 외부서명일 때만, w·h 는 캔버스 크기 — _safety-sign.scss 와 같은 값).
 */
export default class SafetySign {
    initialize() {
        this.d = JSON.parse(document.getElementById('page-data')?.textContent || '{}');
        $('#sign-modal-btn').on('click', () => {
            $j.Ui.BS.open({
                target: '$j.F.Member.ModalSafetySign',
                data: {
                    $p: { w: this.d.w, h: this.d.h },
                    onApply: ($r) => this.handleSign($r),
                },
            });
        });
    }

    /** 서명 결과 처리 */
    handleSign($r) {
        const isMember = !!(window.MEMBER && MEMBER.num > 0);
        const url = isMember ? '/m/ajax/sign/safety/save' : '/m/ajax/sign/safety/remote-save';
        $.ajax({
            url: url,
            type: 'POST',
            data: { base64: $r['sign_data'], mb_no: this.d.mbNo, pass: this.d.pass },
            success: (data) => {
                if (!data.result) {
                    $j.Common.Util.swalert(data.message);
                    return;
                }
                $j.Common.Util.swalert('서명이 완료되었습니다.', () => {
                    location.href = isMember ? '/m' : '/m/sign/done';
                });
            },
        });
    }
}
